<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div slot="header">
            <div class="float-left">
              {{ $lang.edit }} <strong v-text="$lang.assessment_plan" />
            </div>
            <div class="float-right">
              {{ $lang.searchAssessmentPlan.id }}: {{ id }}
            </div>
          </div>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-alert :show="readonly" variant="danger" dismissible>
              <i class="fas fa-info-circle fa-lg mr-1" />
              <strong v-text="$lang.assessmentPlanReadonlyAlert" />
            </b-alert>
            <b-row>
              <b-col xs="12" md="6" class="mb-3">
                <b>{{ $lang.company }}</b
                >: {{ companyName }}
              </b-col>
              <b-col xs="12" md="6" class="mb-3">
                <b>{{ $lang.template }}</b
                >: {{ templateName }}
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.name"
                  label-for="name"
                  :label-cols="this.$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.name"
                    :rules="$v.name.$params"
                  />
                  <b-form-input
                    id="name"
                    type="text"
                    :autocomplete="$lang.name"
                    v-model="$v.name.$model"
                    :state="$v.name.$dirty ? !$v.name.$error : null"
                  />

                  <b-form-invalid-feedback id="name-feedback">
                    {{
                      $lang.error_required | replace($lang.name)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-alert show variant="info" dismissible>
                  <i class="fas fa-info-circle fa-lg mr-1" />
                  <strong v-text="$lang.assessmentPlanAssessorCodeAlert" />
                </b-alert>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  label-for="candidates"
                  :label-cols="this.$config.form.labelCol"
                >
                  <template slot="label">
                    {{ $lang.DefinitionCandidate }}
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      @click="addCandidate"
                      :disabled="readonly"
                    >
                      <i class="fa fa-plus" />
                    </b-button>
                  </template>
                  <b-col
                    cols="12"
                    class="px-0 mb-2"
                    v-for="(v, index) in $v.candidates.$each.$iter"
                    :key="index"
                  >
                    <b-input-group>
                      <b-form-input
                        id="candidates"
                        v-model="v.person_center_execute_code.$model"
                        :state="
                          v.person_center_execute_code.$dirty
                            ? !v.person_center_execute_code.$error
                            : null
                        "
                        autocomplete="off"
                        :placeholder="`${$lang.candidateCode} ${+index + 1}`"
                        :disabled="readonly"
                      />
                      <b-input-group-append>
                        <b-btn
                          @click="removeCandidate(index)"
                          :disabled="readonly"
                        >
                          <i
                            class="fa fa-times fa-lg text-danger"
                            aria-hidden="true"
                          />
                        </b-btn>
                      </b-input-group-append>
                      <b-form-invalid-feedback
                        id="candidates-feedback"
                        class="mt-0"
                      >
                        <div v-if="!v.person_center_execute_code.required">
                          {{
                            $lang.error_required | replace($lang.candidateCode)
                          }}
                        </div>
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  label-for="assessor"
                  :label-cols="this.$config.form.labelCol"
                >
                  <template slot="label">
                    {{ $lang.DefinitionAssessor }}
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="addAssessor"
                      :disabled="readonly"
                      ><i class="fa fa-plus" />
                    </b-button>
                  </template>
                  <b-col
                    cols="12"
                    class="px-0"
                    v-for="(v, index) in $v.assessors.$each.$iter"
                    :key="index"
                  >
                    <b-input-group>
                      <b-form-input
                        id="assessors"
                        v-model="v.person_center_execute_code.$model"
                        :state="
                          v.person_center_execute_code.$dirty
                            ? !v.person_center_execute_code.$error
                            : null
                        "
                        autocomplete="off"
                        :placeholder="`${$lang.assessorCode} ${+index + 1}`"
                        :disabled="readonly"
                      />
                      <b-input-group-append>
                        <b-btn
                          @click="removeAssessor(index)"
                          :disabled="readonly"
                        >
                          <i
                            class="fa fa-times fa-lg text-danger"
                            aria-hidden="true"
                          />
                        </b-btn>
                      </b-input-group-append>
                      <b-form-invalid-feedback
                        id="assessors-feedback"
                        class="mt-0"
                      >
                        <div v-if="!v.person_center_execute_code.required">
                          {{
                            $lang.error_required | replace($lang.assessorCode)
                          }}
                        </div>
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-col>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.room_count"
                  label-for="room_count"
                  :label-cols="this.$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.room_count"
                    :rules="$v.room_count.$params"
                  />
                  <b-form-input
                    id="room_count"
                    type="number"
                    :autocomplete="$lang.room_count"
                    v-model="$v.room_count.$model"
                    :state="$v.room_count.$dirty ? !$v.room_count.$error : null"
                    :disabled="readonly"
                  >
                  </b-form-input>

                  <b-form-invalid-feedback id="room_count-feedback"
                    >{{ $lang.error_required | replace($lang.room_count) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.start_time"
                  label-for="start_time"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.start_time"
                    :rules="$v.start_time.$params"
                  />
                  <date-picker
                    v-model="$v.start_time.$model"
                    :state="$v.start_time.$dirty ? !$v.start_time.$error : null"
                    format="HH:mm"
                    display-format="HH:mm"
                    :jumpMinute="5"
                    type="time"
                    inputReq="true"
                    :roundMinute="true"
                    :class="
                      $v.start_time.$dirty
                        ? $v.start_time.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback id="start_time-feedback"
                    >{{ $lang.error_required | replace($lang.start_time) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="6">
                <b-form-group
                  :label="$lang.end_time"
                  label-for="end_time"
                  :label-cols="12"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.end_time"
                    :rules="$v.end_time.$params"
                  />
                  <date-picker
                    v-model="$v.end_time.$model"
                    :state="$v.end_time.$dirty ? !$v.end_time.$error : null"
                    format="HH:mm"
                    display-format="HH:mm"
                    :jumpMinute="5"
                    type="time"
                    inputReq="true"
                    :roundMinute="true"
                    :class="
                      $v.end_time.$dirty
                        ? $v.end_time.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  ></date-picker>
                  <b-form-invalid-feedback id="end_time-feedback"
                    >{{ $lang.error_required | replace($lang.end_time) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="12">
                <b-form-group
                  :label="$lang.day_count"
                  label-for="day_count"
                  :label-cols="this.$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.day_count"
                    :rules="$v.day_count.$params"
                  />
                  <b-form-input
                    id="day_count"
                    type="number"
                    min="0"
                    :autocomplete="$lang.day_count"
                    v-model="$v.day_count.$model"
                    :state="$v.day_count.$dirty ? !$v.day_count.$error : null"
                    :disabled="readonly"
                  >
                  </b-form-input>

                  <b-form-invalid-feedback id="day_count-feedback"
                    >{{ $lang.error_required | replace($lang.day_count) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer" class="form-group form-btn">
              <b-button
                type="submit"
                size="md"
                v-if="isAdmin(permissions)"
                variant="success"
              >
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required, numeric } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, isAdmin } from "@/shared/utils";

export default {
  name: "edit-assessment-plan",
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  validations: {
    name: {
      required,
    },
    assessor_count: {
      required,
      numeric,
    },
    room_count: {
      required,
      numeric,
    },
    start_time: {
      required,
    },
    end_time: {
      required,
    },
    day_count: {
      required,
    },
    executivePeople: {},
    executivePeopleCode: {},
    candidateCode: {},
    assessorCode: {},
    candidates: {
      $each: {
        person_center_execute_code: {
          required,
        },
        executive_role_id: {},
      },
    },
    assessors: {
      $each: {
        person_center_execute_code: {
          required,
        },
        executive_role_id: {},
      },
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
      executivePeople: null,
      assessors: [],
      candidates: [],
      name: null,
      templateName: null,
      companyName: null,
      assessor_count: 0,
      room_count: 0,
      start_time: "",
      end_time: "",
      day_count: 0,
      permissions: [],
      assessmentPlanTypeLoading: false,
      readonly: true,
    };
  },
  async created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    isAdmin,
    addCandidate() {
      this.candidates.push({
        person_center_execute_code: null,
        executive_role_id: 1,
      });
    },
    addAssessor() {
      this.assessors.push({
        person_center_execute_code: "",
        executive_role_id: 2,
      });
    },
    removeAssessor(index) {
      this.assessors.splice(index, 1);
    },
    removeCandidate(index) {
      this.candidates.splice(index, 1);
    },
    handleBack() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "assessment_plan_id"], [this.id]);
        const payload = {
          assessor_count: this.assessor_count,
          room_count: this.room_count,
          start_time: this.start_time,
          end_time: this.end_time,
          day_count: this.day_count,
          name: this.name,
          persons: [...this.assessors, ...this.candidates],
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      if (!this.id) return;
      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "assessment_plan_id"], [this.id]);
        const response = await this.$httpService.get(url);
        const data = pathOr(null, ["data", "data"], response);
        this.permissions = response.data.permissions;
        this.readonly = pathOr(false, ["readonly"], data);
        this.candidates = pathOr(null, ["candidates"], data);
        this.assessors = pathOr(null, ["assessors"], data);
        this.name = pathOr(null, ["name"], data);
        this.room_count = pathOr(null, ["room_count"], data);
        this.start_time = pathOr(null, ["start_time"], data);
        this.end_time = pathOr(null, ["end_time"], data);
        this.day_count = pathOr(null, ["day_count"], data);
        this.companyName = pathOr(null, ["company", "name"], data);
        this.templateName = pathOr(null, ["template", "caption"], data);
        let assessment_plan_type = pathOr(null, ["assessment_plan_type"], data);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}

*[dir="rtl"] .input-group > .input-group-prepend > .btn,
*[dir="rtl"] .input-group > .input-group-prepend > .input-group-text,
*[dir="rtl"] .input-group > .input-group-append:not(:last-child) > .btn,
*[dir="rtl"]
  .input-group
  > .input-group-append:not(:last-child)
  > .input-group-text,
*[dir="rtl"]
  .input-group
  > .input-group-append:last-child
  > .btn:not(:last-child):not(.dropdown-toggle),
*[dir="rtl"]
  .input-group
  > .input-group-append:last-child
  > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
